import { CLEAR_CONTENT } from "./constantes"

export const clearContent = () => {
    return {
        type: CLEAR_CONTENT,
    }
}